import React, { useEffect, useState } from "react";
import { Card, CardBody, Container } from "reactstrap";
import Breadcrumbs from "../../global/Breadcrumb";

import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";

import { KIBANA_PLM_URL, KIBANA_PLM_INTERNAL_URL } from "../../Common/KibanaAPIEndpoints/KibanaAPIEndpoints";

import { useKibanaAuthentication } from "../../hooks/useKibanaAuthentication";

export default function HostWiseLoadStats() {

  const { setToken } = useKibanaAuthentication();

  const [loading, setLoading] = useState(true)

  useEffect(() => {
    async function fetchInitialData() {
      try {
        setLoading(true);
        await setToken(KIBANA_PLM_URL)
      } catch (err) {
        console.error("Failed to fetch data", err);
      } finally {
        setLoading(false);
      }
    }

    fetchInitialData();
  }, []);

  if(loading) {
    return (
      <Loader type="Puff" color="#00BFFF" height={100} width={100} className='pc-loader' />
    )
  }

  return <Container fluid>
    <Breadcrumbs title="Internal / Devops" parent="Host Wise Load Stats" />
    <Card>
      <CardBody>
        <div className="text-center mb-3">
          <b>Host Wise Load Stats</b><br />
          <a href={`${KIBANA_PLM_INTERNAL_URL}app/infra#/infrastructure/inventory?_g=()&waffleOptions=(autoBounds:!t,boundsOverride:(max:1,min:0),customOptions:!(),groupBy:!(),metric:(type:load),nodeType:host,view:table)`} className="link-primary" target={'_blank'}>Click here to see below graph in kibana</a>
        </div>
        <iframe className="border-0" src={`${KIBANA_PLM_URL}app/infra#/infrastructure/inventory?_g=()&waffleOptions=(autoBounds:!t,boundsOverride:(max:1,min:0),customOptions:!(),groupBy:!(),metric:(type:load),nodeType:host,view:table)&embed=true`} height={'1000'} width='100%'></iframe>
      </CardBody>
    </Card>
  </Container>
}